module["exports"] = ["com", "biz", "info", "name", "net", "org"];